import {
	RESET_SEARCHBAR,
	SET_SEARCH_PLACEHOLDER,
	SET_SEARCH_QUERY
} from '../types/types';

export const hideSearchbarAction = () => (dispatch: any) => {
	dispatch({ type: RESET_SEARCHBAR });
};

export const setSearchQueryAction =
	(searchQuery: string) => (dispatch: any) => {
		dispatch({ type: SET_SEARCH_QUERY, payload: searchQuery });
	};

export const setSearchPlaceholderAction =
	(searchPlaceholder: string) => (dispatch: any) => {
		dispatch({
			type: SET_SEARCH_PLACEHOLDER,
			payload: searchPlaceholder
		});
	};
